export enum CssValueTypeEnum {
  COLOR = 'color',
  LENGTH = 'length',
  FONT_STACK = 'font-stack',
  GRADIENT = 'gradient',
  BORDER = 'border-shorthand',
  FONT_WEIGHT = 'font-weight',
  LENGTH_LIST = 'length-list',
  SHADOW = 'shadow',
  TEXT_TRANSFORM = 'text-transform',
  OBJECT_FIT = 'object-fit',
  JUSTIFY_CONTENT = 'justify-content',
}
export interface ICssVariable {
  type: CssValueTypeEnum
  name?: string
}
export type ICssVariables = Record<string, ICssVariable>
